/**
 * Divider Component
 * Visual separator between content
 */

import React, { forwardRef } from 'react';
import { Box } from './Box';

/**
 * Divider Component
 * A visual separator
 * 
 * @example
 * <Divider />
 * <Divider orientation="vertical" h="50px" />
 */
export const Divider = forwardRef(({
  orientation = 'horizontal',
  variant = 'solid',
  ...props
}, ref) => {
  const isVertical = orientation === 'vertical';

  const horizontalStyles = {
    width: '100%',
    height: 0,
    borderTopWidth: '1px',
    borderStyle: variant,
    borderColor: 'inherit',
  };

  const verticalStyles = {
    height: '100%',
    width: 0,
    borderLeftWidth: '1px',
    borderStyle: variant,
    borderColor: 'inherit',
  };

  return (
    <Box
      ref={ref}
      as="hr"
      role="separator"
      aria-orientation={orientation}
      {...(isVertical ? verticalStyles : horizontalStyles)}
      {...props}
    />
  );
});

Divider.displayName = 'Divider';

export default Divider;
